import {Component} from '@angular/core';

import {GeneralListComponent} from '../../general/list/generalList.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from '../../../../shared/message.service';
import {GroupService} from '../../../services/group.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Group} from '../../../interfaces/group';

@Component({
  selector: 'qm-usergroups',
  templateUrl: '../../general/list/generalList.component.html',
  styleUrls: ['../../general/list/generalList.component.css']
})
export class GroupListComponent extends GeneralListComponent<Group> {

  constructor(
    service: GroupService,
    router: Router,
    messagesService: MessageService,
    modalService: NgbModal,
    route: ActivatedRoute) {
    super(
      service,
      router,
      messagesService,
      route,
      modalService,
      {
        entityNameSingular: 'right group',
        entityNamePlural: 'right groups',
        formUrl: 'rightgroup',
        listUrl: 'rightgroups',
        generalFormMetaName: 'group',
      },
    );
  }
}
